import _ from 'lodash'
import catalogPage from './catalog'

export default {
  type: 'search',
  getTitle(vue) {
    return vue.searchTerms
  },
  getPath(vue) {
    return `/api/articles/${vue.town.id}/search`
  },
  getDataOptionalQueryParams(vue) {
    // Handle multiple filter groups
    const activeGroup = _.find(vue.filterGroups, { kind_id: vue.activeFilterKindId }) || _.first(vue.filterGroups)
    const kindId = activeGroup ? activeGroup.kind_id : vue.kind_id
    const currentKindTags = vue.getKindTags ? vue.getKindTags(kindId) : this.getKindTags(vue, kindId)

    // Group selected tag ids by tag type id
    let tagIdsByAggregatorTagTypeId = {}

    // Filter tag_ids that belong to the current kind
    const kindTagIds = _.map(currentKindTags, 'id')

    if (vue.urlTagIds.length > 0) {
      tagIdsByAggregatorTagTypeId = _.groupBy(
        vue.urlTagIds,
        (id) => {
          let tag = _.find(currentKindTags, t => t.id === id)
          return tag ? 'tag_ids_' + tag.aggregator_tag_type_id : 'tag_ids_unknown'
        }
      )
    }

    // Ensure every tag type present in the kind is represented in params
    const possibleTagTypeIds = _.uniq(_.map(currentKindTags, 'aggregator_tag_type_id'))
    _.each(possibleTagTypeIds, ttId => {
      const paramName = 'tag_ids_' + ttId
      if (!tagIdsByAggregatorTagTypeId[paramName]) {
        tagIdsByAggregatorTagTypeId[paramName] = []
      }
    })

    return _.merge(tagIdsByAggregatorTagTypeId, { search_terms: [vue.searchTerms] })
  },
  getKindTags(vue, kindId) {
    return catalogPage.getKindTags(vue, kindId)
  },
  toggleTag(vue, tag) {
    return catalogPage.toggleTag(vue, tag)
  },
  replaceInPath(vue, key, value) {
    return catalogPage.replaceInPath(vue, key, value)
  },
}
